/**
 * The kinds of business the platform knows about. A copy of packages/shared/business/industries.ts (the web app does
 * not import the shared package, like phone.ts and intakeFields.ts); lib/test/industries.test.ts keeps the two identical.
 * The platform admin sets a business's industry, which decides which industry rules its receptionist follows.
 */
export const INDUSTRIES = [
  { value: "barber", label: "Barber" },
  { value: "salon", label: "Salon" },
  { value: "auto_repair", label: "Auto repair" },
  { value: "real_estate", label: "Real estate" },
  { value: "roofing", label: "Roofing" },
  { value: "trades", label: "Trades" },
  { value: "veterinary", label: "Veterinary" },
  { value: "dental", label: "Dental" },
  { value: "health_clinic", label: "Health clinic" },
  { value: "restaurant", label: "Restaurant" },
  { value: "professional_services", label: "Professional services" },
  { value: "other", label: "Other" },
] as const;

export function isKnownIndustry(value: string | null | undefined): boolean {
  return INDUSTRIES.some((i) => i.value === value);
}

/** "Auto repair" for a known industry; the raw value (or "Not set") otherwise. */
export function industryLabel(value: string | null | undefined): string {
  if (!value) return "Not set";
  return INDUSTRIES.find((i) => i.value === value)?.label ?? value;
}
